import axios from 'axios';
export const sso = {
  methods: {
    sso: function(poller,messageChanger) {
      const self = this;
      const sso_data = {
        "workflow": self.formdata.workflow
      }

      // Make the SSO call
      axios.post( self.remote_server + process.env.SSO_URL, sso_data, { 
        headers: { Authorization: "Bearer " + self.response.token },
        timeout: 15000 
      })
      .then(response => {
        setTimeout(function() {
          clearInterval(poller);
          clearInterval(messageChanger);
          self.showMessage = self.loadingMessages.length - 1;
          self.loadingProgress = self.loadingTime;
          
          if (typeof response.data.redirect === 'undefined') {
            clearInterval(poller);
            self.hasError('Catch', response.data, 'SSO 1', messageChanger);
          }
          else if (response.data.redirect !== 'testSuccess') {
            window.location.href = response.data.redirect;
          }
          else {
            console.log('SSO Success');
          }
        }, 1000);
        
      })
      .catch(e => {
        clearInterval(poller);
        self.hasError('Catch', e, 'SSO 2', messageChanger);
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/exports/methods/sso.js